(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8279],{

/***/ 45018:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmids/[setID]",
      function () {
        return __webpack_require__(12658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: globalCommon  } = __webpack_require__(31668);
const { de: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-sequences": __webpack_require__(99952),
    "section-try-for-free": __webpack_require__(3049)
};


/***/ }),

/***/ 97040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: globalCommon  } = __webpack_require__(31668);
const { en: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-sequences": __webpack_require__(47340),
    "section-try-for-free": __webpack_require__(33686)
};


/***/ }),

/***/ 78548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(97040),
    de: __webpack_require__(98501)
};


/***/ }),

/***/ 12658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _setID_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 11 modules
var smart_react_i18 = __webpack_require__(8610);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js + 2 modules
var DiPageHoC = __webpack_require__(74063);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js + 5 modules
var NextPageWithServices = __webpack_require__(18092);
// EXTERNAL MODULE: ./src/Plasmids/constants/index.js
var constants = __webpack_require__(77106);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Link.js
var Link = __webpack_require__(14594);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/index.js + 1 modules
var PageNavbarSearch = __webpack_require__(59157);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Main.js
var Main = __webpack_require__(23069);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Sidebar.js
var Sidebar = __webpack_require__(68646);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PlasmidElement/index.js
var PlasmidElement = __webpack_require__(28207);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./src/Plasmids/ui/SectionItems/index.js + 3 modules
var SectionItems = __webpack_require__(97703);
// EXTERNAL MODULE: ./src/Plasmids/ui/SectionCopyright/index.js + 1 modules
var SectionCopyright = __webpack_require__(30767);
// EXTERNAL MODULE: ./src/Plasmids/ui/BlockAutocomplete/index.js + 4 modules
var BlockAutocomplete = __webpack_require__(87149);
// EXTERNAL MODULE: ./src/Plasmids/ui/PageNavbarSearch/index.js
var ui_PageNavbarSearch = __webpack_require__(18570);
// EXTERNAL MODULE: ./src/Plasmids/routes/index.js
var routes = __webpack_require__(27404);
// EXTERNAL MODULE: ./src/Plasmids/utils/plasmid/helpers.js
var helpers = __webpack_require__(80702);
;// CONCATENATED MODULE: ./src/Plasmids/templates/Default.js
/* eslint-disable react/prop-types */ 
























const SequencesPageDefaultTemplate = (param)=>{
    let { title , description , setID , downloadFile , sets , sequences  } = param;
    const [t] = (0,smart_react_i18/* useLocale */.bU)("plasmids-sequences");
    const url = (0,react.useMemo)(()=>"https://".concat(routes/* ROUTE_DOMAIN_PROD */.J$).concat((0,helpers/* routeSet */.nA)(setID)), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: title,
                description: description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: title,
                        description: description,
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: url,
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: title,
                        description: description,
                        card: t("META_TWITTER_CARD"),
                        creator: t("META_TWITTER_CREATOR"),
                        site: t("META_TWITTER_SITE"),
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: t("META_ROBOTS")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroRow */.P, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "s",
                                        onClick: ()=>downloadFile(),
                                        children: t("DOWNLOAD_PLASMID_SET")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: ButtonLink/* default */.Z,
                                        href: routes/* ROUTE_FREE_TRIAL */.qd,
                                        styleType: "secondary",
                                        isOutline2: true,
                                        children: t("TRY_SNAPGENE_FOR_FREE")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                        spacing: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                            sx: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Link/* default */.Z,
                                href: routes/* ROUTE_SNAPGENE_VIEWER */.u,
                                children: t("DOWNLOAD_SNAPGENE_VIEWER")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbarSearch/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        children: [
                            t("EXPLORE_OVER_PLASMIDS"),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: routes/* ROUTE_PLASMIDS */.$b,
                                children: t("MORE_PLASMID_SETS")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAutocomplete/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidElement/* PlasmidElementSectionBreadcrumbs */.jM, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Item/* BreadcrumbItemLink */.A,
                                href: routes/* ROUTE_HOME */.XX,
                                children: t("HOME")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Item/* BreadcrumbItemLink */.A,
                                href: routes/* ROUTE_PLASMIDS */.$b,
                                children: t("PLASMIDS")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "sequence",
                title: t("INDIVIDUAL_SEQUENCES_MAPS"),
                setID: setID,
                items: sequences
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "set",
                title: t("PLASMID_SETS"),
                items: sets
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCopyright/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Default = (SequencesPageDefaultTemplate);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionContact/SectionContact.js







const SectionContact = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
        isBorderNone: true,
        spacing: {
            pt: 10,
            pb: 24
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    lg: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                        sx: {
                            textAlign: "center"
                        },
                        children: [
                            "If you have suggestions for additional plasmids or plasmid collections, please",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                href: routes/* ROUTE_CONTACT_US */.ql,
                                children: "contact us"
                            }),
                            "."
                        ]
                    })
                })
            })
        })
    });
/* harmony default export */ var SectionContact_SectionContact = (SectionContact);

;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionContact/index.js


;// CONCATENATED MODULE: ./src/Plasmids/templates/Coronavirus.js
/* eslint-disable react/prop-types */ 



























const SequencesPageCoronavirusTemplate = (param)=>{
    let { title , description , setID , downloadFile , sequences , sets  } = param;
    const [t] = (0,smart_react_i18/* useLocale */.bU)("plasmids-sequences");
    const url = (0,react.useMemo)(()=>"https://".concat(routes/* ROUTE_DOMAIN_PROD */.J$).concat((0,helpers/* routeSet */.nA)(setID)), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: title,
                description: description,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: title,
                        description: description,
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: url,
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: title,
                        description: description,
                        card: t("META_TWITTER_CARD"),
                        creator: t("META_TWITTER_CREATOR"),
                        site: t("META_TWITTER_SITE"),
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: t("META_ROBOTS")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        dangerouslySetInnerHTML: {
                            __html: description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroRow */.P, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "s",
                                        onClick: ()=>downloadFile(),
                                        children: t("DOWNLOAD_GENOMES")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: ButtonLink/* default */.Z,
                                        href: routes/* ROUTE_FREE_TRIAL */.qd,
                                        styleType: "secondary",
                                        isOutline2: true,
                                        children: t("TRY_SNAPGENE_FOR_FREE")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                        spacing: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                            sx: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Link/* default */.Z,
                                href: routes/* ROUTE_SNAPGENE_VIEWER */.u,
                                children: t("DOWNLOAD_SNAPGENE_VIEWER")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbarSearch/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        children: [
                            t("EXPLORE_OVER_PLASMIDS"),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: routes/* ROUTE_PLASMIDS */.$b,
                                children: t("MORE_PLASMID_SETS")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAutocomplete/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidElement/* PlasmidElementSectionBreadcrumbs */.jM, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Item/* BreadcrumbItemLink */.A,
                                href: routes/* ROUTE_HOME */.XX,
                                children: t("HOME")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Item/* BreadcrumbItemLink */.A,
                                href: routes/* ROUTE_PLASMIDS */.$b,
                                children: t("PLASMIDS")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                colCount: 4,
                type: "sequence",
                title: t("GENOMES_AND_PRIMERS"),
                setID: setID,
                items: sequences
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                isBorderNone: true,
                spacing: {
                    py: 0
                },
                className: "text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/snapgene/coronavirus-resources/main.png"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "set",
                title: t("PLASMID_SETS"),
                items: sets
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionCopyright/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionContact_SectionContact, {})
        ]
    });
};
/* harmony default export */ var Coronavirus = (SequencesPageCoronavirusTemplate);

;// CONCATENATED MODULE: ./src/Plasmids/templates/index.js
/* eslint-disable react/prop-types */ 




const SequencesPageTemplate = (param)=>{
    let { typePage , ...props } = param;
    const Template = typePage === constants/* CORONAVIRUS_PAGE_ID */.Bt ? Coronavirus : Default;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Template, {
        ...props
    });
};
/* harmony default export */ var templates = (SequencesPageTemplate);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js + 1 modules
var either = __webpack_require__(71970);
// EXTERNAL MODULE: ./src/Plasmids/providers/getPlasmidSequences.js
var getPlasmidSequences = __webpack_require__(12596);
// EXTERNAL MODULE: ./src/Plasmids/providers/getPlasmidSets.js
var getPlasmidSets = __webpack_require__(31927);
// EXTERNAL MODULE: ./src/Plasmids/utils/encodeURLFragment.js
var encodeURLFragment = __webpack_require__(20566);
;// CONCATENATED MODULE: ./src/Plasmids/resolvers/sequences-resolvers.js





/* harmony default export */ var sequences_resolvers = ((0,props_resolver/* default */.Z)({
    setSequencesData: (param, services)=>{
        let { query  } = param;
        return (0,getPlasmidSequences/* default */.Z)((0,encodeURLFragment/* encodeURLFragment */.Q)(query.setID))(services).then(either/* extRightStrict */.Gs);
    },
    sets: getPlasmidSets/* default */.Z
}));

// EXTERNAL MODULE: ./src/Plasmids/services/sgApiConnection.js
var sgApiConnection = __webpack_require__(41674);
// EXTERNAL MODULE: ./src/Plasmids/services/sgApiClient.js + 3 modules
var sgApiClient = __webpack_require__(96373);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/Plasmids/services/index.js
var services = __webpack_require__(55093);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
// EXTERNAL MODULE: ./locales/plasmids-sequences-page/index.js
var plasmids_sequences_page = __webpack_require__(78548);
var plasmids_sequences_page_default = /*#__PURE__*/__webpack_require__.n(plasmids_sequences_page);
;// CONCATENATED MODULE: ./pages/plasmids/[setID]/index.js
/* eslint-disable react/prop-types */ 



















const PlasmidsSequencesPage = ()=>{
    const siteDomain = config/* publicConfig.STATIC_SITE_DOMAIN */.mn.STATIC_SITE_DOMAIN;
    const { setSequencesData , sets  } = (0,DiPageHoC/* usePageData */.Vi)();
    const { setData , sequences  } = setSequencesData;
    const title = setData.plasmidSetName;
    const description = setData.plasmidSetDesc;
    const setID = setData.set;
    const filename = setData.plasmidSetFilename;
    const downloadFile = (0,react.useCallback)(()=>{
        const fileAnchor = document.createElement("a");
        document.body.appendChild(fileAnchor);
        fileAnchor.href = "https://".concat(siteDomain, "/api/plasmids/download?setID=").concat(setID);
        fileAnchor.click();
        document.body.removeChild(fileAnchor);
    }, [
        siteDomain,
        setID
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        hero: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_react_i18/* LocaleProvider */.Iw, {
                resources: (plasmids_sequences_page_default()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(templates, {
                    typePage: setID,
                    title: title,
                    description: description,
                    setID: setID,
                    filename: filename,
                    downloadFile: downloadFile,
                    sets: sets,
                    sequences: sequences
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
PlasmidsSequencesPage.getInitialProps = sequences_resolvers;
PlasmidsSequencesPage.services = {
    sgApiConn: (param)=>{
        let { sgApiConfig  } = param;
        return (0,sgApiConnection/* default */.Z)(__webpack_require__.g.fetch, sgApiConfig.baseUrl);
    },
    sgApiClient: (param)=>{
        let { sgApiConn  } = param;
        return (0,sgApiClient/* default */.Z)(sgApiConn);
    }
};
PlasmidsSequencesPage.postConditions = [
    [
        (param)=>{
            let { setSequencesData  } = param;
            return !!setSequencesData;
        },
        (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
    ]
];
/* harmony default export */ var _setID_ = ((0,pipe/* default */.Z)(PlasmidsSequencesPage, (0,i18/* WithLocale */._t)({
    resources: (plasmids_sequences_page_default())
}), WithConditions/* default */.ZP, (0,NextPageWithServices/* default */.Z)(services/* serviceCore */.T), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 77106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ CORONAVIRUS_PAGE_ID; },
/* harmony export */   "G8": function() { return /* binding */ EXPLORE_OVER; }
/* harmony export */ });
/* unused harmony exports CLIENT_VERSION, PLASMID_FILE_EXT */
const CLIENT_VERSION = "2.1.2";
const PLASMID_FILE_EXT = ".dna";
const EXPLORE_OVER = "2.7k";
const CORONAVIRUS_PAGE_ID = "coronavirus_resources";


/***/ }),

/***/ 12596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71970);

/** @type {
	(setId: string, plasmidId: string) =>
	(deps: { sgApiClient: import("../interfaces/ISGApiClient").ISGApiClient }) => Promise<Right<Promise<import("../interfaces/ISGApiClient").PlasmidSequences>>
} */ const setSequencesData = (setId)=>(param)=>{
        let { sgApiClient  } = param;
        return sgApiClient.getSequences(setId).then(_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_0__/* .Right */ .O6);
    };
/* harmony default export */ __webpack_exports__["Z"] = (setSequencesData);


/***/ }),

/***/ 30767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionCopyright_SectionCopyright; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionCopyright/SectionCopyright.js





const SectionCopyright = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
        isBorderNone: true,
        spacing: {
            pt: 10,
            pb: 24
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    lg: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        sx: {
                            fontColor: "black--20",
                            textAlign: "center"
                        },
                        children: "The maps, notes, and annotations in the zip file on this page are copyrighted material. This material may be used without restriction by academic, nonprofit, and governmental entities, except that the source must be cited as ’’www.snapgene.com/resources’’. Commercial entities must contact GSL Biotech LLC for permission and terms of use."
                    })
                })
            })
        })
    });
/* harmony default export */ var SectionCopyright_SectionCopyright = (SectionCopyright);

;// CONCATENATED MODULE: ./src/Plasmids/ui/SectionCopyright/index.js



/***/ }),

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 14594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const HeroLink = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "section-hero__link",
        ...props
    });
};
HeroLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLink);


/***/ }),

/***/ 28207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ PlasmidElementSetDescription; },
/* harmony export */   "jM": function() { return /* binding */ PlasmidElementSectionBreadcrumbs; },
/* harmony export */   "lV": function() { return /* binding */ PlasmidElementSetTitleLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74229);
/* harmony import */ var _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72989);






const PlasmidElementSectionBreadcrumbs = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "py-5",
        isBorderNone: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
            children: children
        })
    });
};
PlasmidElementSectionBreadcrumbs.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const PlasmidElementSetTitleLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        Tag: "div",
        sx: {
            fontSize: "l",
            fontColor: "2"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: href,
            ...props,
            children: children
        })
    });
};
PlasmidElementSetTitleLink.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const PlasmidElementSetDescription = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        Tag: "div",
        ...props
    });
};


/***/ }),

/***/ 99952:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","META_DESCRIPTION_CORONAVIRUS":"Download genomes for common coronaviruses such as SARS, MERS, and COVID-19."}');

/***/ }),

/***/ 47340:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","META_DESCRIPTION_CORONAVIRUS":"Download genomes for common coronaviruses such as SARS, MERS, and COVID-19."}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8610,3308,2458,3918,4735,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(45018); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);